import React, { useState } from "react";
import MainPanel from "./Main";
import SettingPart from "./SettingPart";
import { Store } from "../state/state";
import SelectTemplate from "../pages/SelectTemplate";
const Templete = ({}) => {
  const [openGuide, setOpenGuide] = useState(true);
  return (
    <div className=" h-screen flex  w-screen relative  bg-primary">
      <MainPanel />
      <SettingPart />

      <SelectTemplate
        open={openGuide}
        onClose={() => setOpenGuide(false)}
      ></SelectTemplate>
    </div>
  );
};

export default Templete;
